import {Grid2} from '@mui/material';

export default Grid2;
